import { useContext } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router';

import { Heading1 } from '@components/commons';
import Image from '@components/Image';
import PARIS_DAY from '@data/series/paris_day';
import PARIS_NIGHT from '@data/series/paris_night';
import { Trad } from '@types';
import { formatStartEndDates } from '@utils/formatters';
import { getStartEndDates } from '@utils/getters';
import { DataContext } from '@utils/useData';
import { IntlContext } from '@utils/useIntl';

const LocationsParis = () => {
  const { locale, translateTrad } = useContext(IntlContext);
  const { photos } = useContext(DataContext);

  const dayPhotos = photos.filter(({ seriesIds }) =>
    seriesIds?.includes(PARIS_DAY.id),
  );
  const dayCover =
    dayPhotos.find(({ seriesCover }) => !!seriesCover) || dayPhotos[0];
  const dayDates = getStartEndDates(dayPhotos);

  const nightPhotos = photos.filter(({ seriesIds }) =>
    seriesIds?.includes(PARIS_NIGHT.id),
  );
  const nightCover =
    nightPhotos.find(({ seriesCover }) => !!seriesCover) || nightPhotos[0];
  const nightDates = getStartEndDates(dayPhotos);

  return (
    <div className="desktop:py-12">
      <Helmet>
        <title>Marc Malignan | Paris</title>
      </Helmet>
      <Heading1 className="desktop:hidden mb-10 text-center">Paris</Heading1>
      <div className="tablet:flex tablet:gap-8 desktop:gap-20 max-w-[900px] mx-auto">
        <section className="grow basis-0">
          <Link to={`/locations/paris/${PARIS_DAY.id}`}>
            <Image
              photo={dayCover}
              label={translateTrad(PARIS_DAY.name as Trad)}
              labelSub={formatStartEndDates(
                dayDates.start,
                dayDates.end,
                locale,
              )}
            />
          </Link>
        </section>
        <section className="grow basis-0 max-tablet:mt-8">
          <Link to={`/locations/paris/${PARIS_NIGHT.id}`}>
            <Image
              photo={nightCover}
              label={translateTrad(PARIS_NIGHT.name as Trad)}
              labelSub={formatStartEndDates(
                nightDates.start,
                nightDates.end,
                locale,
              )}
            />
          </Link>
        </section>
      </div>
    </div>
  );
};

export default LocationsParis;
